import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '@/firebase'
import router from '@/router'
import codebase from '@/store/codebase'

Vue.use(Vuex)

var state = {
  loading: false,
  user: null
}

var mutations = {
  setUser (state, value) {
    state.user = value
  }
}

var getters = {
  currentUser (state) {
    return state.user
  }
}
var provider = new firebase.auth.GoogleAuthProvider()

var actions = {
  loginGoogle ({ dispatch, commit }) {
    return firebase.auth().signInWithPopup(provider).then(() => {
      // dispatch('checkLogin')
    }, (err) => {
      console.log(err)
    })
  },
  login ({ dispatch, commit }) {
    var email = window.prompt('email?')
    var password = window.prompt('password?')
    firebase.auth().signInWithEmailAndPassword(email, password).catch((error) => {
      dispatch('checkLogin')

      // Handle Errors here.
      var errorCode = error.code
      var errorMessage = error.message
      console.log(errorCode, errorMessage)
    })// login
  },
  logout ({ dispatch, commit }) {
    firebase.auth().signOut().then(() => {
      dispatch('checkLogin')
    }).catch((error) => {
      dispatch('checkLogin')
      console.log(error)
    })
  },
  checkLogin ({ state }) {
    if (state.user && router.currentRoute.path === '/login') {
      router.replace('/')
    } else if (!state.user && router.currentRoute.path !== '/login') {
      router.replace('/login')
    }
  }
}

var onAuthChange = store => {
  firebase.auth().onAuthStateChanged((user) => {
    store.commit('setUser', user || false)
  })// check auth
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [onAuthChange]
})

export default store

codebase.use(store)



// WEBPACK FOOTER //
// ./src/store/index.js